<template>
  <div style="height: 100%;">
    <div>
      <Header />
      <div class="main-wrapper">
          <div class="policy-detail-header">
            <div class="title">
              {{policyName}}
            </div>
            <div class="tag-container">
              <span class="tag">
                {{policyType}}
              </span>
             <!-- <span class="tag">
                {{}}
              </span> -->
            </div>
            <div class="header-bottom">
              <div class="left">
                <p>{{'发布机构：'+publisherBody}}</p>
                <p>{{'发布时间：'+publishTime}}</p>
              </div>
              <div class="right">
                <span class="btn" @click="policyQA">政策咨询</span>
              </div>
            </div>
          </div>
          <div class="policy-detail-content">
            <!-- <div class="policy-detail-content__header">
              <p>
                为繁荣科技出版事业，促进科技创新，推动国家创新驱动发展战略实施，根据国家科学技术学术著作出版基金（以下简称“学术著作出版基金”）工作安排，现发布2021年度学术著作出版基金项目资助申请指南              。
              </p>
              <p style="margin-top: 20px;">项目申报时间：2020年8月1日至9月30日。</p>
              <p style="margin-top: 20px;">特此通知。</p>
            </div> -->
            <div class="policy-detail-content__bottom">
             <!-- <div class="title">
                <p>国家科学技术学术著作出版基金委员会</p>
              </div> -->
              <div class="content" v-html="content">

              </div>
              <!-- <div class="option">
                <span>展开</span>
                <span>收起</span>
              </div> -->
              <div class="extra-info">
                <!-- <p>
                  {{'发布时间：'+publishTime}}
                </p> -->
               <!-- <p>
                  附件下载：  <span class="blue mr16">附件包1</span><span class="blue mr16">附件包2</span>
                </p> -->
                <!-- <p>
                  原文链接：  <span class="blue">http://www.nsfc.gov.cn/publish/portal0/tab442/info78444.htm</span>
                </p> -->
              </div>
            </div>
          </div>
      </div>
      <Footer :isLogin="true" />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import {getPolicy} from '@/api/policy.js';
import Nav from '@/components/Nav.vue';
export default {
    name: 'PolicyDetail',
    components: {
      Nav,
        Header,
        Footer,
    },
    watch: {
        $route(to, from) {}
    },
    data() {
        return {
          pid:0,
          cityId:"", //1
          cityName:"", //"北京市"
          content:"", //""
          governmentType:"", //1
          policyLevel:"", //2"",
          policyName:"", //"关于征集北京市高精尖产业技能提升培训机构和第二批培训项目的通知"
          policyType:"", //"人才计划"
          provinceId:"", //3648
          publishTime:"", //"2020-04-03"
          publisherBody:"", //"北京市经济信息化局"
          status:"", //2
          level:[0,'国家级','省级','市级','区级']
        }
    },
    mounted() {
      this.pid = this.$route.query.pid;
      this.queryDetail()
    },
    methods: {
        policyQA() {
            this.$router.push(`/policy-qa?title=${this.policyName}`);
        },
        queryDetail() {
          this.$http.get(getPolicy(this.pid)).then((res) => {
            if (res.code === 1) {
              console.log(res);
              this.initData(res.data);
            }
          });
        },
        initData(data){
          const keys = Object.keys(data);
          keys.forEach((key) => {
            this[key] = data[key];
            if(key==='policyLevel'){
              var lv = data[key]
              this[key]=this.level[lv]
            }
          });
        },
    }
}
</script>

<style scoped>
.main-wrapper {
  width: 9.44rem;
  margin: .2rem auto;
}
.policy-detail-header, .policy-detail-content {
  background-color: #fff;
  padding: .4rem 1.2rem;
}
.policy-detail-header .title {
  font-size: 20px;
  color: #333333;
  line-height: .3rem;
  margin-bottom: .16rem;
}
.tag {
  width: .6rem;
  height: .22rem;
  background:rgba(38, 127, 242, 0.2);
  color: rgba(38, 127, 242, 1);
  padding: .03rem .06rem;
  margin-right: .1rem;
}
.btn {
  width: 1.08rem;
  height: .32rem;
  line-height: .32rem;
  background: #267FF2;
  color: #fff;
  display: inline-block;
  text-align: center;
  cursor: pointer;
}
.header-bottom {
  margin-top: .4rem;
}
.header-bottom .left {
  display: inline-block;
  color: #666666;
}
.header-bottom .left p {
  margin-top: .08rem;
}
.header-bottom .right {
  float: right;
  margin-top: .1rem;
}
.policy-detail-content {
  margin-top: .1rem;
}
.policy-detail-content__header {
  font-size: 12px;
  color: #666666;
  line-height: .16rem;
  padding-bottom: .1rem;
  border-bottom: solid 1px rgba(240, 240, 240, 1);
}
.policy-detail-content__bottom .title {
  margin-top: .16rem;
  font-size: 20px;
  color: #333333;
  text-align: center;
  margin-bottom: .3rem;
}
.policy-detail-content__bottom .content {
  font-size: 12px;
  color: #666666;
}
.policy-detail-content__bottom .option {
  border-bottom: solid 1px rgba(240, 240, 240, 1);
  padding-bottom: .3rem;
  padding-top: .2rem;
  color: rgba(38, 127, 242, 1);
}
.policy-detail-content__bottom .option span {
  margin-right: .36rem;
}
.policy-detail-content__bottom .extra-info {
  font-size: 12px;
  padding-top: .16rem;
}
.extra-info p {
  margin-bottom: .08rem;
  color: #333333;
  word-break: break-all;
}
.blue {
  color: rgba(38, 127, 242, 1);
}
.mr16 {
  margin-right: .16rem;
}
@media screen and (max-width: 850px){
  .main-wrapper {
    width: auto;
    margin: .2rem;
    box-sizing: border-box;
  }
  .policy-detail-header, .policy-detail-content {
    padding: .34rem;
    box-sizing: border-box;
  }
  .policy-detail-header .title {
    font-size: 40px;
    line-height: 57px;
    text-align: justify;
  }
  .btn {
    width: 272px;
    height: 80px;
    line-height: 80px;
    background: #267FF2;
  }
  .header-bottom .right {
    float: unset;
    text-align: center;
    margin-top: 40px;
  }
  .policy-detail-content__header {
    font-size: 29px;
    line-height: 40px;
  }
  .policy-detail-content__bottom .title {
    font-size: 40px;
  }
  .policy-detail-content__bottom .content,
  .policy-detail-content__bottom .extra-info {
    font-size: 29px;
  }
}
</style>
